module.exports = __webpack_public_path__ + "static/img/02-caseService.aa67108.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter/02-caseService.png
// module id = feBT
// module chunks = 1